<template>
    <div class="blog-post__header" v-if="post">

        <section class="btn-section">
            <router-link class="button button--back scroll-post__back" :to="'/blog/'">
                <Icon/>
                <span>Back to blog</span>
            </router-link>
        </section>

        <section class="byline-section">
            <p class="blog-post__item">
                <i class="far blog-post__item--icon fa-clock"></i>
                <cmscontent :content="formatDate(post.date)"/>
            </p>

            <p class="blog-post__item">
                <router-link 
                    class="blog-post__item--link"
                    :style="{ textDecoration: 'none' }"
                    :to="{ name: 'blogauthor', params: { name: post.author_name } }"
                >
                <i class="fas blog-post__item--icon fa-portrait"></i> 
                    <cmscontent :content="post.author_name"/>
                </router-link>
            </p>

            <p class="blog-post__item">
                <router-link 
                    class="blog-post__item--link"
                    :style="{ textDecoration: 'none' }"
                    :to="{ name: 'blogcategory', params: { slug: post.cat_name[0].slug } }"
                >
                <i class="fas blog-post__item--icon fa-tag"></i>
                    <cmscontent :content="post.cat_name[0].name "/>
                </router-link>
            </p>
        </section>

    </div>
</template>

<script>
export default {

    props: ['post'],

    methods: {
        formatDate(date) {
        let options = { 
            day: 'numeric', 
            year: 'numeric', 
            month: 'long' 
        }

        let postDate = new Date(date);

        return postDate.toLocaleDateString('en-US', options);
        },
    }

}
</script>

<style>

</style>